export default {"src":"/_next/static/media/smoke.dade1333.svg","height":172,"width":172};